// scroll bar
import 'simplebar/src/simplebar.css';

// editor
import 'react-quill/dist/quill.snow.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';

// UPDATED: Import from /client
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
import { Buffer } from 'buffer';

import { AuthProvider } from './contexts/JWTContext';
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';
import App from './App';

// ----------------------------------------------------------------------

// @ts-ignore
window.Buffer = window.Buffer || Buffer;

// 1. Get the root element from your HTML
const container = document.getElementById('root');

// 2. Create a root. (The '!' is a TypeScript non-null assertion)
const root = ReactDOM.createRoot(container!);

// 3. Render your application
root.render(
  <AuthProvider>
    <FeatureFlagProvider>
      <HelmetProvider>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </HelmetProvider>
    </FeatureFlagProvider>
  </AuthProvider>
);
